import React from 'react'
import './GeneralOverview.scss'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import { CurrencyFormatter } from 'Helpers'
import { useNavigate } from 'react-router-dom'
import tradegridLogoBlue from 'Assets/Images/Dashboard/general-overview/tradegrid-logo-blue.png'
import tradegridPlusLogo from 'Assets/Images/Dashboard/general-overview/tradegrid-plus.png'
import boostXpressLogo from 'Assets/Images/Dashboard/general-overview/boostxpress-logo.svg'
import terminalOneLogo from 'Assets/Images/Dashboard/general-overview/terminalone-logo.png'
import boostLogo from 'Assets/Images/Dashboard/general-overview/boost-logo.png'
import tradersCardLogo from 'Assets/Images/Dashboard/general-overview/traderscard-logo.png'
import arrowUpGreen from 'Assets/Images/Dashboard/general-overview/arrow-up-green.svg'

const GeneralOverview = () => {
  const { user } = useAuth()
  const name = user?.user?.name ?? 'Admin'
  const navigate = useNavigate()

  return (
    <div className='general-overview'>
      <div className='container'>
        <div className='go-banner mb-4'>
          <div className='go-banner__content'>
            <div className='go-banner__welcome'>Welcome Back, {name}</div>
            <div className='go-banner__subtitle'>Here&apos;s your TradeGrid summary</div>
          </div>
        </div>

        <div className='row g-4'>
          <div className='col-12 col-md-6'>
            <div
              className='card go-card go-card--170 go-card--1929 go-card--clickable h-100'
              role='button'
              tabIndex={0}
              onClick={() => navigate('/general-overview/tradegrid-overview')}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  navigate('/general-overview/tradegrid-overview')
                }
              }}
            >
              <div className='card-body text-start d-flex justify-content-start'>
                <img src={tradegridLogoBlue} className='go-card__logo go-card__logo--tradegrid' />
                <div className='go-card__label'>Total Users</div>
                <div className='go-card__value'>1500</div>
                <div className='go-card__delta'>
                  <img src={arrowUpGreen} className='go-card__delta-icon' />
                  <span className='go-card__delta-up'>5%</span>
                  <span className='go-card__delta-text'>+100 new users</span>
                </div>
              </div>
            </div>
          </div>

          <div className='col-12 col-md-6'>
            <div
              className='card go-card go-card--170 go-card--clickable h-100'
              role='button'
              tabIndex={0}
              onClick={() => navigate('/general-overview/tgplus-overview')}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  navigate('/general-overview/tgplus-overview')
                }
              }}
            >
              <div className='card-body'>
                <img src={tradegridPlusLogo} className='go-card__logo go-card__logo--plus' />
                <div className='go-card__label'>Total Active Subscribers</div>
                <div className='go-card__value'>250 Subs</div>
                <div className='go-card__delta'>
                  <img src={arrowUpGreen} className='go-card__delta-icon' />
                  <span className='go-card__delta-up'>5%</span>
                  <span className='go-card__delta-text'>+10 New Subscribers</span>
                </div>
              </div>
            </div>
          </div>

          <div className='col-12 col-md-6'>
            <div
              className='card go-card go-card--170 go-card--clickable h-100'
              role='button'
              tabIndex={0}
              onClick={() => navigate('/general-overview/boostxpress-overview')}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  navigate('/general-overview/boostxpress-overview')
                }
              }}
            >
              <div className='card-body'>
                <img src={boostXpressLogo} className='go-card__logo go-card__logo--boostxpress' />
              </div>
            </div>
          </div>

          <div className='col-12 col-md-6'>
            <div className='card go-card go-card--170 go-card--muted-value h-100'>
              <div className='card-body'>
                <img src={terminalOneLogo} className='go-card__logo go-card__logo--terminalone' />
                <div className='go-card__label'>Total Active Orders</div>
                <div className='go-card__value'>₦{CurrencyFormatter(56000000)}</div>
                <div className='go-card__delta'>
                  <img src={arrowUpGreen} className='go-card__delta-icon' />
                  <span className='go-card__delta-up'>5%</span>
                  <span className='go-card__delta-text'>+5M this week</span>
                </div>
              </div>
            </div>
          </div>

          <div className='col-12 col-md-6'>
            <div className='card go-card go-card--182 h-100'>
              <div className='card-body'>
                <div className='go-card__logo-row'>
                  <img src={tradegridLogoBlue} className='go-card__logo go-card__logo--tradegrid' />
                  <div className='go-card__tag'>[EMP]</div>
                </div>
                <div className='go-card__label'>Total Number of Employees</div>
                <div className='go-card__value'>40 Employees</div>
                <div className='go-card__delta'>
                  <img src={arrowUpGreen} className='go-card__delta-icon' />
                  <span className='go-card__delta-up'>5%</span>
                  <span className='go-card__delta-text'>+5L Sold this week</span>
                </div>
              </div>
            </div>
          </div>

          <div className='col-12 col-md-6'>
            <div
              className='card go-card go-card--182 go-card--clickable h-100'
              role='button'
              tabIndex={0}
              onClick={() => navigate('/general-overview/boost-overview')}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  navigate('/general-overview/boost-overview')
                }
              }}
            >
              <div className='card-body'>
                <img src={boostLogo} className='go-card__logo go-card__logo--boost' />
                <div className='go-card__label'>Total Boost Orders</div>
                <div className='go-card__value'>56,000L</div>
                <div className='go-card__delta'>
                  <img src={arrowUpGreen} className='go-card__delta-icon' />
                  <span className='go-card__delta-up'>5%</span>
                  <span className='go-card__delta-text'>+5L Sold this week</span>
                </div>
              </div>
            </div>
          </div>

          <div className='col-12'>
            <div
              className='card go-card go-card--203 go-card--clickable'
              role='button'
              tabIndex={0}
              onClick={() => navigate('/general-overview/traderscard-overview')}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  navigate('/general-overview/traderscard-overview')
                }
              }}
            >
              <div className='card-body'>
                <img src={tradersCardLogo} className='go-card__logo go-card__logo--traderscard' />

                <div className='row g-3 mt-2'>
                  <div className='col-12 col-md-4'>
                    <div className='go-metric'>
                      <div className='go-metric__label'>Total Active Users</div>
                      <div className='go-metric__value'>2500</div>
                      <div className='go-metric__delta'>
                        <img src={arrowUpGreen} className='go-card__delta-icon' />
                        <span className='go-card__delta-up'>5%</span>
                        <span className='go-card__delta-text'>+10 Requests</span>
                      </div>
                    </div>
                  </div>

                  <div className='col-12 col-md-4'>
                    <div className='go-metric'>
                      <div className='go-metric__label'>Total Lease Assets</div>
                      <div className='go-metric__value'>₦{CurrencyFormatter(2000000000)}</div>
                      <div className='go-metric__delta'>
                        <img src={arrowUpGreen} className='go-card__delta-icon' />
                        <span className='go-card__delta-up'>5%</span>
                        <span className='go-card__delta-text'>+5M in Lease this week</span>
                      </div>
                    </div>
                  </div>

                  <div className='col-12 col-md-4'>
                    <div className='go-metric'>
                      <div className='go-metric__label'>Total Active Orders</div>
                      <div className='go-metric__value'>₦{CurrencyFormatter(56000000)}</div>
                      <div className='go-metric__delta'>
                        <img src={arrowUpGreen} className='go-card__delta-icon' />
                        <span className='go-card__delta-up'>5%</span>
                        <span className='go-card__delta-text'>+5M this week</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='go-footer mt-4 mb-4'>© 2026 Tradegrid - All rights reserved.</div>
      </div>
    </div>
  )
}

export default GeneralOverview
